/* eslint quotes: ["error", "double"]  */

const question = "Structuring data..."

const choices = [
  {
    answer: "Enables us find relevant information more quickly",
    correct: false,
    feedback: "Structuring data does help us search more efficiently, but it also helps in other ways."
  },
  {
    answer: "Gives meaning to information",
    correct: false,
    feedback: "Structure can be used to help describe data, but it has other advantages as well."
  },
  {
    answer: "Helps us manage large amounts of data",
    correct: false,
    feedback: "While structure is key to working with data at scale, it can also offer other benefits."
  },
  {
    answer: "All of the above!",
    correct: true,
    feedback: "Great job! Properly structured data has many advantages!"
  }
]

export default {
  question,
  choices
}
